<template lang="pug">
	.versions-search-bar(v-if="Publisher.SelectedPublisher && Publisher.SelectedPublisher.id" :class="Layout.versionsFilter ? 'filter-exist' : ''")
		.search-input-cont
			.search-icon.fa.fa-search
			input.search-input(ref="input" placeholder="Filter versions..." v-model="filter" @input="filterVersions")
			.search-remove-icon.fa.fa-remove(v-on:click="removeFilter")
</template>

<script>
	import Screen from './../../mixins/screen'

	import { Publisher } from './../../services/Publisher'
	import { Project } from './../../services/Project'
	import { Layout } from './../../services/Layout'

	export default {
		name: 'VersionsSearchBar',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Selected Publisher Changed", "Project Fully Loaded", "Versions Filter Changed"],
			events: {
				"Versions Filter Changed": function(reason) {

					if (reason === "from-local-storage") this.filter = Layout.versionsFilter;

				}
			}
		},
		components: {},
		data() {

			this.Publisher = Publisher;
			this.Project = Project;

			return {
				showed: true,
				filter: Layout.versionsFilter
			};
		},
		methods: {

			collectData() {



			},

			openPreview() {

				if (!Version.SelectedVersion) return;

				if (_.size(Version.VersionPreviewsByVersionByHash[Version.SelectedVersion.id]) > 0) Broadcast.call("Show ProjectVersionPreviewList");
				else Broadcast.call("Show ProjectVersionPreviewCreate");

			},

			filterVersions() {

				Layout.setVersionsFilter(this.filter);

			},

			removeFilter() {

				this.filter = '';

				Layout.setVersionsFilter('');

			}

		}
	}
</script>

<style lang="sass">

	.versions-search-bar
		height: 32px
		text-align: center
		overflow: hidden
		margin-top: 10px
		margin-bottom: -16px
		margin-left: -16px
		margin-right: -16px
		border-top: 1px solid #23282c

		.search-input-cont
			position: relative
			display: flex
			flex-wrap: wrap
			align-items: stretch
			height: 32px
			background-color: rgba(255, 255, 255, 0.00)
			transition: background-color 0.35s ease-in-out

			.search-icon
				width: 30px
				height: 30px
				display: flex
				align-items: center
				justify-content: center
				color: white

				&::before
					opacity: 0.1
					transition: opacity 0.35s ease-in-out

			.search-input
				border: none
				color: rgba(255, 255, 255, 0.17)
				outline: none
				width: 189px
				height: 30px
				background-color: transparent

			.search-remove-icon
				width: 30px
				height: 30px
				display: flex
				align-items: center
				justify-content: center
				color: white

				&::before
					opacity: 0
					transition: opacity 0.35s ease-in-out

		.search-input-cont:focus-within,
		&.filter-exist
			background-color: rgba(255, 255, 255, 0.10)

			.search-icon

				&::before
					opacity: 1

			.search-input
				color: rgba(255, 255, 255, 0.87)

			.search-remove-icon


		&.filter-exist

			.search-remove-icon

				&::before
					opacity: 1
					cursor: pointer

</style>

